import { TimelineMax, Power3 } from 'gsap';
import background from '@/scripts/background';

const SliderPrev = (element) => {
  const current = element.querySelector('.slide--current');
  const next = element.querySelector('.slide--next');
  const empty = element.querySelector('.slide--empty');
  const nextText = element.querySelector('.slide--next p');

  background.ref.prepareSlide('prev');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start-images')
    .addLabel('start-texts', 'start-images+=0.4')
    .set(current, { xPercent: -30, autoAlpha: 0 })
    .to(current, 1.2, {
      xPercent: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'start-texts')
    .to(next, 1.2, {
      xPercent: 66,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'start-texts')
    .to(empty, 1.2, {
      xPercent: 170,
      autoAlpha: 0,
      ease: Power3.easeInOut,
    }, 'start-texts')
    .to(nextText, 1.2, {
      autoAlpha: 0,
      ease: Power3.easeInOut,
    }, 'start-texts')
    .to(background.ref.transitionWaterEffectScale, 1.2, {
      x: 100,
      y: 100,
      ease: Power3.easeIn,
    }, 'start-images')
    .to(background.ref.transitionWaterEffectScale, 1.2, {
      x: 0,
      y: 0,
      ease: Power3.easeOut,
    }, 'start-images+=1.2')
    .to(background.ref.bottleDistortionEffectScale, 1.2, {
      x: 400,
      y: 400,
      ease: Power3.easeIn,
    }, 'start-images')
    .to(background.ref.bottleDistortionEffectScale, 1.2, {
      x: 0,
      y: 0,
      ease: Power3.easeOut,
    }, 'start-images+=1.2')
    .to(background.ref.textDistortionEffectScale, 1.2, {
      x: 100,
      y: 100,
      ease: Power3.easeIn,
    }, 'start-images')
    .to(background.ref.textDistortionEffectScale, 1.2, {
      x: 0,
      y: 0,
      ease: Power3.easeOut,
    }, 'start-images+=1.2')
    .to(background.ref.current.sprite, 2.4, {
      x: background.ref.app.renderer.width / 2,
      alpha: 1,
      ease: Power3.easeInOut,
    }, 'start-images')
    .add(() => { background.ref.disposeSlide('prev'); });
  return tl;
};

export default SliderPrev;
